import { useEffect } from 'react';

import { waitForRenderAssets } from './renderReady';

declare global {
  interface Window {
    __CV_PDF_READY__?: boolean;
  }
}

const READY_DATA_ATTRIBUTE = 'cvPdfReady';

export function usePdfPrintReady(
  enabled: boolean,
  containerRef: React.RefObject<HTMLElement | null>,
  isLayoutReady: boolean,
): void {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    window.__CV_PDF_READY__ = false;
    delete document.documentElement.dataset[READY_DATA_ATTRIBUTE];

    if (!isLayoutReady || !containerRef.current) {
      return;
    }

    let cancelled = false;

    const markReady = async () => {
      await waitForRenderAssets();

      if (cancelled || !containerRef.current) {
        return;
      }

      window.__CV_PDF_READY__ = true;
      document.documentElement.dataset[READY_DATA_ATTRIBUTE] = 'true';
    };

    void markReady();

    return () => {
      cancelled = true;
      window.__CV_PDF_READY__ = false;
      delete document.documentElement.dataset[READY_DATA_ATTRIBUTE];
    };
  }, [enabled, containerRef, isLayoutReady]);
}
